module.exports = __webpack_public_path__ + "media/images/lb/757-fa46c32c0923e3958aadb2faf5134d34.svg";